import {
  DEPARTMENT_ALL,
  DEPARTMENT_GET,
  DEPARTMENT_DEL,
  DEPARTMENT_PUT,
  DEPARTMENT_POST,
  DEPARTMENT_LOADING,
  DEPARTMENT_ERROR,
} from '../../actions/types';

const initialState = {
  department: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case DEPARTMENT_LOADING:
      return { ...state, isLoading: true, isCompleted: true };
    case DEPARTMENT_ERROR:
      return { ...state, isLoading: false, isCompleted: false };
    case DEPARTMENT_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case DEPARTMENT_GET:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case DEPARTMENT_POST:
      return { ...state, isLoading: false, isCompleted: true };
    case DEPARTMENT_PUT: {
      const payloadId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && payloadId
          ? state.rows.map((r) =>
              (r._id || r.id) === payloadId ? { ...r, ...action.payload } : r,
            )
          : state.rows,
      };
    }
    case DEPARTMENT_DEL: {
      const delId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && delId
          ? state.rows.filter((r) => (r._id || r.id) !== delId)
          : state.rows,
        total: state.rows && delId ? Math.max((state.total || 1) - 1, 0) : state.total,
      };
    }
    default:
      return state;
  }
}
